
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import Mission from './components/Mission';
import TimelinePreview from './components/TimelinePreview';
import Memorial2025 from './components/Memorial2025';
import Contact from './components/Contact';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Mission />
        <TimelinePreview />
        <Memorial2025 />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
